"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSIValueWithDeclaration = formatSIValueWithDeclaration;
exports.formatSIValue = formatSIValue;
exports.formatSIOrSymbolicValueWithDeclaration = formatSIOrSymbolicValueWithDeclaration;
exports.formatSIOrSymbolicValue = formatSIOrSymbolicValue;
exports.canonicalizeVariancePrefix = canonicalizeVariancePrefix;
exports.formatVariance = formatVariance;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const symbolic_comparison_1 = require("./symbolic-comparison");
function formatSIValueWithDeclaration(raw, declaration) {
    const trimmed = raw?.trim() ?? '';
    if (!trimmed) {
        return '';
    }
    try {
        const parsed = sigma_engine_shared_1.Utils.parseNumericalSIValue(trimmed, declaration);
        if (parsed === undefined) {
            return trimmed;
        }
        const decimalPlaces = Math.max(0, Math.round(-Math.log10(declaration.epsilon ?? 1e-9)));
        return String(Number(parsed.toFixed(decimalPlaces)));
    }
    catch {
        return trimmed;
    }
}
function formatSIValue(raw, characteristic) {
    return formatSIValueWithDeclaration(raw, sigma_engine_shared_1.BoundaryCharacteristicSIDefinitions[characteristic]);
}
function formatSIOrSymbolicValueWithDeclaration(raw, declaration) {
    const asSI = formatSIValueWithDeclaration(raw, declaration);
    return Number.isFinite(Number(asSI)) && asSI !== '' ? asSI : (0, symbolic_comparison_1.foldSymbolicValue)(asSI, declaration);
}
function formatSIOrSymbolicValue(raw, characteristic) {
    return formatSIOrSymbolicValueWithDeclaration(raw, sigma_engine_shared_1.BoundaryCharacteristicSIDefinitions[characteristic]);
}
function canonicalizeVariancePrefix(raw) {
    return (raw?.trim() ?? '').replace(/^\+\/-\s*/, '±');
}
function formatVariance(raw) {
    const trimmed = canonicalizeVariancePrefix(raw);
    if (!trimmed) {
        return '';
    }
    if (/^±$/.test(trimmed)) {
        return '';
    }
    return trimmed;
}
//# sourceMappingURL=si-comparison.js.map